import { makeStyles, createStyles } from '../../styles';
export default makeStyles((theme) => createStyles({
    root: {
        display: 'block',
        fontWeight: 700,
        textTransform: 'uppercase',
        letterSpacing: 1.42,
        lineHeight: 1.11,
        fontSize: theme.fontSizes.xxs,
        color: theme.palette.text.primary,
        marginBottom: theme.spacing(1),
    },
    error: {
        color: theme.palette.error.main,
    },
    disabled: {
        color: theme.palette.text.disabled,
    },
}));
//# sourceMappingURL=InputLabel.styles.js.map